import { Link, ModalWidth, RemoveIcon, ShowModalEventInterceptor } from '@dreryk/react-components';

import { GuardianModalFormBean } from '../../../common/GuardianModal/GuardianModal.types';
import { guardiansTranslationKeys } from '../../../translations';

type GuardianDeleteIconProps = {
   readonly guardian: GuardianModalFormBean;
   readonly onDelete: (variables: GuardianModalFormBean) => void;
};

export const GuardianDeleteIcon = (props: GuardianDeleteIconProps): JSX.Element => {
   return (
      <ShowModalEventInterceptor
         testId={'removeGuardian'}
         shouldShowModal
         title={guardiansTranslationKeys.removeGuardian}
         content={guardiansTranslationKeys.doYouWantToRemoveGuardian}
         confirmationButtonLabel={guardiansTranslationKeys.remove}
         modalWidth={ModalWidth.NORMAL}
      >
         <Link onClick={() => props.onDelete(props.guardian)} icon={<RemoveIcon />} testId={'remove'} />
      </ShowModalEventInterceptor>
   );
};
